import * as $ from 'jquery';
import { IAvatar } from './IAvatar';

interface AvatarDelta {
  x: number;
  y: number;
}

interface AvatarSourceRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

class SimpleAvatar implements IAvatar {
  private Element: JQuery;

  // optional information about displacement from the mouse pointer
  public readonly avatarDelta?: AvatarDelta;
  // optional information about where the avatar is coming from
  public readonly avatarSource?: AvatarSourceRect;

  public constructor(innerHtml: string, delta?: AvatarDelta, source?: AvatarSourceRect) {
    this.avatarDelta = delta;
    this.avatarSource = source;
    this.Element = $(`<span>${innerHtml}</span>`);
  }

  public get_rootElement(): JQuery<HTMLElement> {
    return this.Element;
  }

  public addToDom(parent: JQuery): void {
    parent.append(this.Element);
  }

  public dispose(): void {
    /** */
  }
}

export { AvatarDelta, AvatarSourceRect, SimpleAvatar };
